export default "__VITE_ASSET__BTrrNZuA__"